<template>
  <div>
    <div class="mkt-container">
      <div class="header">
        <div class="header-title">{{title}}</div>
      </div>
      <div class="right">
        <div style="height: calc(100vh - 80px);">
          <Stepper v-model="dataCampaign" :stepNo="step" style="height: calc(100vh - 140px);"></Stepper>

          <div v-if="Mode=='edit'">
            <md-button class="md-raised" @click="cancelEdit()">Cancel</md-button>
            <md-button class="md-raised md-primary" @click="saveEdit()">Save</md-button>
            <!-- <md-button class="md-raised md-primary btn-publish" @click="saveEditPublish()">Publish</md-button> -->
          </div>
          <div v-else>
            <div
              v-if="permit.acl['campaign'].menus['create'].add == true || permit.acl['campaign'].menus['create'].edit == true"
            >
              <md-button class="md-raised btn-save-to-draft" @click="saveToDraft()">Save to Draft</md-button>
              <!-- <md-button class="md-raised md-primary btn-publish" @click="savePublish()" :disabled=toPublish>Publish</md-button> -->
              <md-button
                class="md-raised md-primary btn-publish"
                @click="onSendToApprove()"
                :disabled="toPublish"
              >Send to approve</md-button>
            </div>
          </div>
        </div>
      </div>
      <div class="left">
        <md-card style="height: auto;">
          <Step1 ref="frm_step_1" v-if="step==1" v-model="dataCampaign"></Step1>
          <Step2 ref="frm_step_2" v-if="step==2" v-model="dataCampaign"></Step2>
          <Step3 ref="frm_step_2" v-if="step==3" v-model="dataCampaign"></Step3>

          <md-card-actions
            class="mktops-action-button md-bottom-left"
            v-if="permit.acl['campaign'].menus['create'].add == true || permit.acl['campaign'].menus['create'].edit == true"
          >
            <md-button class="mktops-button-back-next" @click="backStep()" v-if="step!=1">back</md-button>
            <md-button class="md-primary" @click="nextStep()" v-if="step!=3">next</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>

    <md-dialog :md-active.sync="validate">
      <md-dialog-title style="color:red;">Warning !!!</md-dialog-title>
      <div style="padding-left:5vmin;padding-bottom:1vmin;">
        <p>Please fill necessary field on</p>
        <p v-for="(item,index) in dataAlert" :key="index">-{{item}}</p>
      </div>
      <center>
        <md-button class="md-primary" @click="validate = false">Close</md-button>
      </center>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="openConfirmUpdate"
      md-title="Update a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmUpdate"
    />

    <md-dialog-confirm
      :md-active.sync="openConfirmCreate"
      md-title="Create a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmCreate"
    />

    <md-dialog-confirm
      :md-active.sync="openConfirmDraft"
      md-title="Save to draft a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmDraft"
    />

    <md-dialog-confirm
      :md-active.sync="openConfirmEditPublish"
      md-title="Publish a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmEditPublish"
    />

      <md-dialog-alert
      :md-active.sync="showAlert"
      :md-title="alertTitle"
      :md-content="alertContent" />

  </div>



</template>

<script>
import CampaignService from "@/services/campaign";

import Stepper from "./stepper";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

export default {
  name: "campaign-manage",
  components: {
    Stepper,
    Step1,
    Step2,
    Step3
  },
  props: {
    title: String,
    data: Object,
    goToStep: Number,
    Mode: String
    // step: Number
  },
  watch: {
    step(value) {
      if (value == 3) this.toPublish = false;
      else this.toPublish = true;
    }
  },
  computed: {
    stepTxt() {
      return "step-" + this.step;
    },
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    }
  },
  data() {
    return {
      dataCampaign: this.data,
      step: 1,
      dataAlert: [],
      toPublish: true,
      openConfirmUpdate: false,
      openConfirmCreate: false,
      openConfirmDraft: false,
      openConfirmEditPublish: false,
      validate: false,
      showAlert: false,
      alertTitle: "",
      alertContent: ""
    };
  },
  created() {
    if (this.goToStep) this.step = this.goToStep;
  },
  methods: {
    backStep() {
      this.step--;
      if (this.step < 1) this.step = 1;
    },
    nextStep() {
      if (this.step == 1) {
        if (!this.$refs.frm_step_1.isValidate()) {
          return;
        }
      }

      if (this.step == 2) {
        if (this.dataCampaign.products.length < 1) {
          // alert("Please select at least one item");
          this.showAlert = true;
          this.alertTitle = "";
          this.alertContent = "Please select at least one item";
          return;
        }
      }

      this.step++;
      if (this.step > 3) this.step = 3;
    },
    cancelEdit() {
      this.$emit("onCancel");
    },
    saveEdit() {
      if (this.step == 1) {
        if (!this.$refs.frm_step_1.isValidate()) {
          return;
        }
      }
      this.openConfirmUpdate = true;
    },
    saveToDraft() {

      if (this.step == 1) {
        if (!this.$refs.frm_step_1.isValidate()) {
          return;
        }
      }

      this.openConfirmDraft = true;
    },
    saveEditPublish() {
      this.openConfirmEditPublish = true;
    },
    savePublish() {
      console.log(this.dataCampaign);
      this.dataAlert = [];
      if (this.dataCampaign.campaign_code == null) {
        this.dataAlert.push("Campaign Code");
        this.validate = true;
      }
      if (this.dataCampaign.campaign_title == null) {
        this.dataAlert.push("Campaign Title");
        this.validate = true;
      }
      if (this.dataCampaign.enddate == null) {
        this.dataAlert.push("Campaign End Date");
        this.validate = true;
      }
      if (this.dataCampaign.startdate == null) {
        this.dataAlert.push("Campaign Start Date");
        this.validate = true;
      }
      for (let a = 0; a < this.dataCampaign.sets.length; a++) {
        if (this.dataCampaign.sets[a].customers.length == 0) {
          this.dataAlert.push("Sets " + (a + 1) + " Customer");
          this.validate = true;
        }
        if (this.dataCampaign.sets[a].name == "") {
          this.dataAlert.push("Sets " + (a + 1) + " Name");
          this.validate = true;
        }
        if (this.dataCampaign.sets[a].point == null) {
          this.dataAlert.push("Sets " + (a + 1) + " Point");
          this.validate = true;
        }
      }
      if (this.validate == false) {
        this.openConfirmCreate = true;
      }
    },
    onConfirmUpdate() {
      this.$emit("onSave", this.dataCampaign);
    },
    onConfirmCreate() {
      this.$emit("onPublish", this.dataCampaign);
    },
    onConfirmDraft() {
      this.$emit("onSaveToDraft", this.dataCampaign);
    },
    onConfirmEditPublish() {
      this.$emit("onConfirmEditPublish", this.dataCampaign);
    },
    onSendToApprove() {
      this.$emit("onSendToApprove", this.dataCampaign);
    }
  }
};
</script>


<style lang="scss" scoped>
.btn-save-to-draft {
  background: #a8a8a8 !important;
  color: white !important;
  width: 40%;
}
.btn-publish {
  width: 50%;
}

.header-title {
  // margin:10px;
  font-size: 18px;
  // margin-left:20px;
  padding-left: 20px;
  padding-top: 10px;
  margin-bottom: 10px;
  font-family: Lato;
  color: #797979;
}

.main-content {
  height: calc(100vh - 90px);
  .content {
    float: left;
    width: 75%;
  }
  .sidebar {
    float: left;
    width: 25%;
  }
}

// .content {
//   height: calc(100vh - 100px);
//   .left-content {
//     // min-width:75%
//   }
//   .right-content {
//     width: 250px;
//     // min-width:25%
//   }
// }

.mkt-btn-next {
  color: blue;
}
.mkt-form-step {
  .md-card-header {
    padding: 0px;
    height: 70px;

    // .card-title {
    //   // padding-top:20px !important;
    //   //margin-top: 20px !important;

    // }

    .md-avatar {
      margin-left: 30px;
      margin-top: 17px;
    }

    .card-title {
      // padding-top:50px;
    }
  }
}

.mkt-container {
  //  height: auto;
  height: calc(100vh);
  overflow: hidden;
  min-width: 800px;

  .header {
    // height: 20px;
    // background: red;
  }

  .right {
    width: 320px;
    float: right;
    padding-left: 10px;
    padding-right: 20px;
    // background: #aafed6;
  }

  .left {
    float: none; /* not needed, just for clarification */
    // background: #e8f6fe;
    /* the next props are meant to keep this block independent from the other floated one */
    width: auto;
    overflow: hidden;
    padding: 0px 20px 10px 20px;
  }
}
</style>